import script from "./InoutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InoutPage.vue?vue&type=script&setup=true&lang=ts"

import "./InoutPage.vue?vue&type=style&index=0&id=06dbd08e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06dbd08e"]])

export default __exports__